import store from '@/store';

if (navigator && navigator.connection) {
  // Poll downlink speed from navigator every 10 sec
  setInterval(() => {
    const speed = navigator.connection.downlink;
    store.commit('downlink', speed);
  }, 10000);
  const speed = navigator.connection.downlink;
  store.commit('downlink', speed);
}
